import { useEffect, useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { openContactModal } from './ContactModal'

const NAV_ITEMS: Array<
  | { to: string; label: string }
  | { href: string; label: string; external?: boolean }
> = [
  { to: '/', label: 'LLM' },
  { to: '/fde', label: 'fde' },
  { to: '/roadmap', label: 'roadmap' },
]

function LogoMark() {
  return (
    <span className="od-logo-mark" aria-hidden="true">
      <img className="td-logo-on-dark" src="/logo.png" alt="" decoding="async" />
      <img className="td-logo-on-light" src="/logo-on-light.png" alt="" decoding="async" />
    </span>
  )
}

export default function SiteNav() {
  const location = useLocation()
  const isHowActive = location.pathname === '/' && location.hash === '#how'
  const [menuOpen, setMenuOpen] = useState(false)

  useEffect(() => {
    setMenuOpen(false)
  }, [location.pathname, location.hash])

  useEffect(() => {
    if (!menuOpen) return

    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'

    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setMenuOpen(false)
    }
    const onClickOutside = (e: MouseEvent) => {
      const t = e.target as Element | null
      if (!t) return
      if (t.closest('.od-nav')) return
      setMenuOpen(false)
    }
    window.addEventListener('keydown', onKey)
    window.addEventListener('click', onClickOutside)
    return () => {
      document.body.style.overflow = previousOverflow
      window.removeEventListener('keydown', onKey)
      window.removeEventListener('click', onClickOutside)
    }
  }, [menuOpen])

  return (
    <header className={`od-nav${menuOpen ? ' is-menu-open' : ''}`}>
      <Link to="/" className="od-brand" aria-label="TokenDance home">
        <LogoMark />
      </Link>

      <nav aria-label="Primary" id="od-nav-menu">
        {NAV_ITEMS.map((item) =>
          'href' in item ? (
            <a
              key={item.href}
              href={item.href}
              className={item.href === '/#how' && isHowActive ? 'is-active' : undefined}
              target={item.external ? '_blank' : undefined}
              rel={item.external ? 'noopener noreferrer' : undefined}
              onClick={() => setMenuOpen(false)}
            >
              {item.label}
            </a>
          ) : (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) => (isActive ? 'is-active' : undefined)}
              onClick={() => setMenuOpen(false)}
            >
              {item.label}
            </NavLink>
          ),
        )}
      </nav>

      <button
        type="button"
        className="od-nav-hamburger"
        aria-label={menuOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={menuOpen}
        aria-controls="od-nav-menu"
        onClick={() => setMenuOpen((v) => !v)}
      >
        <span aria-hidden="true" />
        <span aria-hidden="true" />
        <span aria-hidden="true" />
      </button>

      <button
        type="button"
        className="od-nav-dashboard"
        aria-label="Email TokenDance"
        onClick={() => {
          setMenuOpen(false)
          openContactModal()
        }}
      >
        talk to us
      </button>
    </header>
  )
}
